<template>
    <div>
        <HeaderContent header="คำสั่งซื้อ" :img_header="header_image" link_back="content" />
        <MenuContentPurchase/>
        <ContentOrderList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/box.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentPurchase from '@/components/menuadmin/content/contentpurchase/MenuContentPurchase.vue'
import ContentOrderList from '@/components/menuadmin/content/contentpurchase/ContentOrderList.vue'

export default {
    name:'contentOrder',
    components:{
        HeaderContent,
        MenuContentPurchase,
        ContentOrderList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>